import { useMediaQuery } from '@mui/material'
import { type Theme } from '@mui/material/styles'

/**
 * Breakpoint utilisé dans certains composants pour gérer l'affichage custom entre lg et xlg
 */
export const WIDE_BREAKPOINT = 1280

export const useIsMediumUp = (theme: Theme): boolean => useMediaQuery(theme.breakpoints.up('md'))

export const useIsLargeUp = (theme: Theme): boolean => useMediaQuery(theme.breakpoints.up('lg'))

export const useIsWideUp = (theme: Theme): boolean => useMediaQuery(theme.breakpoints.up(WIDE_BREAKPOINT))

// Using this hook with NextJS will break ServerSide Rendering
export const useIsLargeUpCSR = (theme: Theme): boolean => useMediaQuery(theme.breakpoints.up('lg'), { noSsr: true })
